import {
	CUSTOMERS_REQUEST,
	CUSTOMERS_REQUEST_SUCCESS,
	CUSTOMERS_REQUEST_FAILURE,
	CUSTOMERS_FILTERS_REQUEST,
	CUSTOMERS_FILTERS_REQUEST_SUCCESS,
	CUSTOMERS_FILTERS_REQUEST_FAILURE,
	CUSTOMERS_SET_ACTIVE_FILTER,
	CUSTOMERS_SET_ACTIVE_FILTER_PAGE,
	CUSTOMERS_FILTER_ATTRS_GET_SUPPOSE,
	CUSTOMERS_FILTER_ATTRS_GET_SUPPOSE_SUCCESS,
	CUSTOMERS_FILTER_ATTRS_GET_SUPPOSE_FAIL,
	CUSTOMERS_ADD_FILTER_ATTRS,
	CUSTOMERS_SAVE_FILTER_SUCCESS,
	CUSTOMERS_SAVE_FILTER_FAIL,
	CUSTOMERS_SAVE_FILTER,
	CUSTOMERS_DELETE_FILTER,
	CUSTOMERS_DELETE_FILTER_SUCCESS,
	CUSTOMERS_DELETE_FILTER_FAIL,
	CUSTOMERS_FILTER_PARAMS_GET_SUPPOSE,
	CUSTOMERS_FILTER_PARAMS_GET_SUPPOSE_SUCCESS,
	CUSTOMERS_FILTER_PARAMS_GET_SUPPOSE_FAIL,
	CUSTOMERS_FILTER_ATTRS_CLEAR_RESULT,
	CUSTOMERS_CLEAR_FILTER_ATTRS,
	CUSTOMERS_CLEAR_FILTER_INFO,
	CUSTOMERS_FILTER_DATA_GET_SUPPOSE,
	CUSTOMERS_FILTER_DATA_GET_SUPPOSE_SUCCESS,
	CUSTOMERS_FILTER_DATA_GET_SUPPOSE_FAIL,
	CUSTOMERS_OPEN_FILTER_PARAMS,
	CUSTOMERS_CLOSE_FILTER_PARAMS,
	CUSTOMERS_OPEN_NEW_FILTER_PARAMS,
	CUSTOMERS_CLOSE_NEW_FILTER_PARAMS,
	CUSTOMERS_CREATE_NEW_FILTER,
	CUSTOMERS_FILTER_LIST_GET_SUPPOSE,
	CUSTOMERS_FILTER_LIST_GET_SUPPOSE_SUCCESS,
	CUSTOMERS_FILTER_LIST_GET_SUPPOSE_FAIL,
	CUSTOMERS_FILTER_LIST_CLEAR_RESULT,
	CUSTOMERS_ADD_FILTER_OPTION,
	CUSTOMERS_SET_OLD_FILTER_DATA,
	CUSTOMERS_CLEAR_NEW_FILTER_OPTION,
	CUSTOMERS_CLEAR_FILTER_DATA,
	CUSTOMERS_APPLY_EXISTING_FILTER,
	CUSTOMERS_SET_SELECT_OPTIONS_FOR_FILTER,
} from 'constants/actions';
import { omit } from 'lodash';

/* initial state */
const initialState = {
	filters: null,
	
	loading: false,
	loaded: false,
	filterAttrsResults: [],
	checkedFilterAttrs: {},
	saving: false,
	saved: false,
	deleting: false,
	infoLoading: false,
	infoLoaded: false,
	infoFilterParams: [],
	filterList: [],
	loadingFilterList: false,
	loadedFilterList: false,
	lastSaved: '',
	dataLoading: false,
	dataLoaded: false,
	dataFilterResult: null,
	openedFilter: null,
	showFilterParams: false,
	newFilter: false,
	showDeleteFilterModal: false,
	newFilterOption: null,
	oldFilterData: null,
};

/* reducer */
export default (state = initialState, action) => {
	switch (action.type) {
		case CUSTOMERS_FILTERS_REQUEST_SUCCESS:
			return { ...state, filters: action.filters };
			
		case CUSTOMERS_SET_ACTIVE_FILTER:
			return { ...state, openedFilter: action.openedFilter };
			
		case CUSTOMERS_SET_ACTIVE_FILTER_PAGE:
			const filters = state.filters;
			const currentIndex = filters.findIndex(filter => filter.filterId === action.filterId);
			const currentFilter = {...filters.find(filter => filter.filterId === action.filterId), page: action.page};
			filters[currentIndex] = currentFilter;

			return { ...state, filters };
			
		case CUSTOMERS_FILTER_ATTRS_GET_SUPPOSE:
			return {
				...state,
				loading: true,
				loaded: false
			};
		
		case CUSTOMERS_FILTER_ATTRS_GET_SUPPOSE_SUCCESS:
			return {
				...state,
				loading: false,
				loaded: true,
				filterAttrsResults: action.result.result
			};
		
		case CUSTOMERS_FILTER_ATTRS_GET_SUPPOSE_FAIL:
			return {
				...state,
				loading: false,
				loaded: false,
				error: action.err
			};

		case CUSTOMERS_FILTER_ATTRS_CLEAR_RESULT:
			return {
				...state,
				filterAttrsResults: []
			};
		
		case CUSTOMERS_ADD_FILTER_ATTRS:
			
			return {
				...state,
				checkedFilterAttrs: action.result.result
			};
		
		case CUSTOMERS_CLEAR_FILTER_ATTRS:
			return {
				...state,
				checkedFilterAttrs: {}
			};
		
		case CUSTOMERS_SAVE_FILTER:
			return {
				...state,
				saving: true,
				saved: false
			};
		
		case CUSTOMERS_SAVE_FILTER_SUCCESS:
			const { lastSaved } = action;
			return {
				...state,
				saving: false,
				saved: true,
				newFilter: false,
				lastSaved
			};
		case CUSTOMERS_SAVE_FILTER_FAIL:
			return {
				...state,
				saving: false,
				saved: false,
				error: action.err
			};
		
		case CUSTOMERS_DELETE_FILTER:
			return {
				...state,
				deleting: true,
				deleted: false
			};
		
		case CUSTOMERS_DELETE_FILTER_SUCCESS:
			let stateFilters = state.filters;
			const currentDeletedIndex = stateFilters.findIndex(filter => filter.filterId === +action.id);
			stateFilters.splice(currentDeletedIndex, 1);
			return {
				...state,
				deleting: false,
				deleted: true,
				id: action.id,
				stateFilters
			};
		
		case CUSTOMERS_DELETE_FILTER_FAIL:
			return {
				...state,
				deleting: false,
				deleted: false,
				error: action.err
			};
		
		case CUSTOMERS_FILTER_PARAMS_GET_SUPPOSE:
			return {
				...state,
				infoLoading: true,
				infoLoaded: false
			};
		
		case CUSTOMERS_FILTER_PARAMS_GET_SUPPOSE_SUCCESS:
			return {
				...state,
				infoLoading: false,
				infoLoaded: true,
				infoFilterParams: action.result.result,
				saved: false
			};
		
		case CUSTOMERS_FILTER_PARAMS_GET_SUPPOSE_FAIL:
			return {
				...state,
				infoLoading: false,
				infoLoaded: false,
				error: action.err
			};
		
		case CUSTOMERS_CLEAR_FILTER_INFO:
			return {
				...state,
				infoFilterParams: []
			};
			
		case CUSTOMERS_FILTER_LIST_GET_SUPPOSE:
			return {
				...state,
				loadingFilterList: true,
				loadedFilterList: false
			};
		
		case CUSTOMERS_FILTER_LIST_GET_SUPPOSE_SUCCESS:
			return {
				...state,
				loadingFilterList: false,
				loadedFilterList: true,
				filterList: action.result.result
			};
		
		case CUSTOMERS_FILTER_LIST_GET_SUPPOSE_FAIL:
			return {
				...state,
				loadingFilterList: false,
				loadedFilterList: false,
				error: action.err
			};
		case CUSTOMERS_FILTER_LIST_CLEAR_RESULT:
			return {
				...state,
				filterList: []
			};
		
		case CUSTOMERS_ADD_FILTER_OPTION:
			return {
				...state,
				filterList: [
					...state.filterList,
					action.payload
				],
				newFilterOption: action.payload
			};
		
		case CUSTOMERS_SET_OLD_FILTER_DATA:
			return {
				...state,
				oldFilterData: action.payload
			};
		
		case CUSTOMERS_CLEAR_NEW_FILTER_OPTION:
			return {
				...state,
				newFilterOption: null
			};
		
		case CUSTOMERS_FILTER_DATA_GET_SUPPOSE:
			return {
				...state,
				dataLoading: true,
				dataLoaded: false
			};
		
		case CUSTOMERS_FILTER_DATA_GET_SUPPOSE_SUCCESS:
			
			return {
				...state,
				dataLoading: false,
				dataLoaded: true,
				dataFilterResult: action.result.result
			};
		
		case CUSTOMERS_FILTER_DATA_GET_SUPPOSE_FAIL:
			return {
				...state,
				dataLoading: false,
				dataLoaded: false,
				error: action.err
			};
		
		case CUSTOMERS_CLEAR_FILTER_DATA:
			return {
				...state,
				dataFilterResult: null
			};
		
		case CUSTOMERS_OPEN_FILTER_PARAMS:
			return {
				...state,
				showFilterParams: true,
				newFilter: false
			};
		
		case CUSTOMERS_CLOSE_FILTER_PARAMS:
			return {
				...state,
				showFilterParams: false
			};
		
		case CUSTOMERS_OPEN_NEW_FILTER_PARAMS:
			return {
				...state,
				showFilterParams: true,
				newFilter: true
			};
		
		case CUSTOMERS_CLOSE_NEW_FILTER_PARAMS:
			return {
				...state,
				showFilterParams: false,
				newFilter: false
			};
		
		case CUSTOMERS_CREATE_NEW_FILTER:
			return {
				...state,
				newFilter: true
			};
		
		case CUSTOMERS_APPLY_EXISTING_FILTER:
			return {
				...state,
				newFilter: false
			};

		case CUSTOMERS_SET_SELECT_OPTIONS_FOR_FILTER:
			const { options, optionsHistory } = action;
			return {
				...state,
				selectOptions: options,
				optionsHistory
			};
		
		default:
			return state;
	}
};
